var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"logo-font",attrs:{"to":{ name: 'home', params: {} }}},[_vm._v("\n      Sharemonkie\n    ")]),_c('span',{staticClass:"attribution"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }